export const BACKEND_HOST = "https://api.behaton.me" || "http://localhost:6767"
export const AUTH_TOKEN = "admin_panel_token"

// Public host of the R2 bucket. Images are stored in the DB as bare file names.
export const FILES_HOST = "https://s3.behaton.me"

// Bare file name -> full URL for previews; full URLs pass through unchanged.
export const fileUrl = value => value && !/^https?:\/\//.test(value) ? `${FILES_HOST}/${value}` : value

// Full R2 URL from the API -> bare file name, so saving keeps the DB free of hosts.
export const toFileName = value => value?.startsWith(`${FILES_HOST}/`) ? value.slice(FILES_HOST.length + 1) : value
